import { CASHFLOW_GROSS_EXPENSE_CLASS_NAME, CASHFLOW_GROSS_INCOME_CLASS_NAME } from '../../config/constants';

export const useCashflowChartCallbacks = () => {
    const addColumnPadding = () => {
        const grossIncomeColumns = document.getElementsByClassName(CASHFLOW_GROSS_INCOME_CLASS_NAME);
        const grossExpenseColumns = document.getElementsByClassName(CASHFLOW_GROSS_EXPENSE_CLASS_NAME);
        if (grossIncomeColumns.length > 0) {
            addColumnPaddingTop(grossIncomeColumns);
        }
        if (grossExpenseColumns.length > 0) {
            addColumnPaddingBottom(grossExpenseColumns);
        }
    };

    const addColumnPaddingTop = (columns: HTMLCollectionOf<any>) => {
        for (let i = 0; i < columns.length; i++) {
            const column = columns[i];
            const y = moveUp(column.point.shapeArgs.y);
            const height = column.point.shapeArgs.height + 5;
            if (height > 5) {
                column.setAttribute('height', height.toString());
                column.setAttribute('y', y.toString());
            }
        }
    };

    const moveUp = (yPosition: number) => yPosition - 5;

    const addColumnPaddingBottom = (columns: HTMLCollectionOf<any>) => {
        for (let i = 0; i < columns.length; i++) {
            const column = columns[i];
            const height = column.point.shapeArgs.height + 5;
            if (height > 5) {
                column.setAttribute('height', height.toString());
            }
        }
    };

    return { addColumnPadding };
};
